let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9cOwI")).then(() => parcelRequire('gMjb0'));